import { cn } from "@/lib/utils";
import { Paragraph } from "@ui/paragraph";
import type { ReactNode } from "react";

export default function ProductCardBrand({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <Paragraph
      className={cn(
        "all-small-caps truncate text-sm tracking-wider overflow-ellipsis whitespace-nowrap uppercase",
        className,
      )}
    >
      {children}
    </Paragraph>
  );
}

ProductCardBrand.displayName = "ProductCardBrand";
